import {
	Directive,
	Input,
	Output,
	EventEmitter,
	HostListener,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { ErrorDialogComponent } from '../utilities/error-dialog/error-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';

@Directive({
	selector: '[rpsharedConfirm]',
})
export class ConfirmDirective {
	@Input('rpsharedConfirm') warnText = 'Are you sure?';
	@Input() shouldConfirm = true;
	// tslint:disable-next-line: no-output-rename
	@Output('onConfirmed') confirmed = new EventEmitter();
	// tslint:disable-next-line: no-input-rename
	@Input('guard') cannotProceedMessage = '';

	constructor(private warnDialog: MatDialog) {}

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		if (!this.cannotProceedMessage) {
			if (this.shouldConfirm) {
				this.warnDialog
					.open(AlertDialogComponent, {
						data: { message: this.warnText },
					})
					.afterClosed()
					.pipe(filter(Boolean))
					.subscribe(() => this.confirmed.emit(event));
			} else {
				this.confirmed.emit(event);
			}
		} else {
			this.warnDialog
				.open(ErrorDialogComponent, { data: this.cannotProceedMessage })
				.afterClosed()
				.pipe(filter(Boolean))
				.subscribe(() => this.confirmed.emit(event));
		}
	}
}
